import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=c0ff9f6c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=c0ff9f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ff9f6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0ff9f6c')) {
      api.createRecord('c0ff9f6c', component.options)
    } else {
      api.reload('c0ff9f6c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=c0ff9f6c&scoped=true&", function () {
      api.rerender('c0ff9f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8RWzUnBTxZfWp/JS/comp/SearchFilterTokens.vue"
export default component.exports